import { tableDefaults } from "./defaultConfig.js";

export const roleTableConfig = () => ({
    ...tableDefaults,
    index: "id",
    columns: [
        {
            title: "Rolle",
            field: "name",
            widthGrow: 1,
            headerFilter: "input",
            headerFilterFunc: (headerValue, rowValue, rowData) =>
                String(rowData.name ?? "").toLowerCase().includes(headerValue.toLowerCase()),
        },
        { title: "Berechtigungen", field: "permissionId", widthGrow: 6, headerFilter: "list" },
    ],
});